import { render } from "./AdminLocations.vue?vue&type=template&id=86636e82&scoped=true"
import script from "./AdminLocations.vue?vue&type=script&lang=js"
export * from "./AdminLocations.vue?vue&type=script&lang=js"

import "./AdminLocations.vue?vue&type=style&index=0&id=86636e82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86636e82"]])

export default __exports__